export const BOOKING_SLOT_SELECTION = `
    id
    timeGap
    dayOfWeek
    bookingNumberLimit
    startTime
    endTime
    shop {
        id
        name
    }
    bookingSlotCount (page: 0, limit: 30){
        docs {
            id
            count
        }
    }
`;

export const LOAD_BOOKING_SLOT_SELECTION = `
    id
    displayTitle
    timeGap
    dayOfWeek
    bookingNumberLimit
    startTime
    endTime
    shop {
        id
        name
    }

`;;

export const bookingSlotOff = (
  date?: string,
  limit?: number,
  page?: number,
  sort?: string,
  where?: any,
  useVariable?: boolean // Flag to indicate if we should use $date variable
) => {
  // Build the GraphQL fragment with proper formatting
  const params = [];
  
  // For now, we'll build the where clause directly for the date case
  // since that's the primary use case
  if (date && !where && !useVariable) {
    // Build the where clause directly in GraphQL syntax (no JSON.stringify)
    params.push(`where: {AND: [{date: {equals: "${date}"}}]}`);
  } else if (useVariable) {
    // Use the $date variable from the query
    params.push(`where: {AND: [{date: {equals: $date}}]}`);
  } else if (where) {
    // For custom where clauses, we need to build them as GraphQL syntax
    console.warn('Custom where clauses in bookingSlotOff need to be passed as GraphQL variables instead');
  }
  
  // Add other parameters
  if (limit !== undefined) {
    params.push(`limit: ${limit}`);
  } else {
    params.push(`limit: 1`); // Default to 1 as per the example query
  }
  
  if (page !== undefined) {
    params.push(`page: ${page}`);
  }
  
  if (sort !== undefined && sort !== null) {
    params.push(`sort: "${sort}"`);
  } else {
    params.push(`sort: "date"`); // Default sort by date
  }

  const paramsString = params.length > 0 ? `(${params.join(', ')})` : '';

  return `bookingSlotOff${paramsString} {
          docs {
              id
              date
              value
          }
          hasNextPage
      }`;
};;;;;;

export const bookingSlotCount = (date: string) => {
  if (!date) return "";
  return `bookingSlotCount (page: 1, limit: 50, where: {
        bookingDate: {
            equals: "${date}"
        }
    }){
        docs {
            id
            count
        }
    }`;
};
